import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

const classes = {
	countdown: "js-m-stage-event__countdown-time",
	activeDays: "state-m-stage-event__show-days",
	shareBtn: "js-m-stage-event__share-btn",
	activeShare: 'state-m-stage-event__share-container--open',
	registerBtn: 'js-m-stage-event__register',
	registerForm: 'js-m-stage-event__register-form',
	activeRegisterBtn: 'state-m-stage-event__register--open',
	activeRegisterForm: 'state-m-stage-event__register--open',
};

@createModule('StageEvent')
export class StageEvent extends TerrificSpec {
	$ctx: JQuery;

	start(resolve: Function) {
		this.$ctx = $(this._ctx);

		this.initCountdown();
		this.initShare();
		this.toggleRegisterForm();
		resolve();
	}

	stop() {}

	initCountdown() {
		const $countdown = this.$ctx.find(`.${classes.countdown}`);
		const totalseconds = parseInt($countdown.data('second'));
		if (totalseconds > 86400) {
			$countdown.text(Math.floor(totalseconds / 24 / 3600));
			$countdown.addClass(classes.activeDays)
		} else {
			var me = this;
			setInterval(function () {
				me.calculator();
			}, 1000);
		}
	}

	calculator() {
		const $countdown = this.$ctx.find(`.${classes.countdown}`);
		const totalseconds = parseInt($countdown.data('second'));
		const nextseconds = totalseconds - 1;
		const h = Math.floor(nextseconds / 3600) < 10 ? '0' + Math.floor(nextseconds / 3600) : Math.floor(nextseconds / 3600);
		const m = Math.floor((nextseconds / 60 % 60)) < 10 ? '0' + Math.floor((nextseconds / 60 % 60)) : Math.floor((nextseconds / 60 % 60));
		const s = Math.floor((nextseconds % 60)) < 10 ? '0' + Math.floor((nextseconds % 60)) : Math.floor((nextseconds % 60));
		$countdown.data('second', nextseconds);
		$countdown.text(h + ":" + m + ":" + s);
	}

	initShare() {
		const $shareBtn = this.$ctx.find(`.${classes.shareBtn}`);
		$shareBtn.on('click', (ev: Event) => {
			ev.stopPropagation();
			$(ev.currentTarget).parent().toggleClass(classes.activeShare);
		});
		$('body').on('click', () => {
			$shareBtn.parent().removeClass(classes.activeShare);
		});
	}

	toggleRegisterForm() {
		const $registerBtn = this.$ctx.find(`.${classes.registerBtn}`);
		const $registerForm = this.$ctx.find(`.${classes.registerForm}`);
		$registerBtn.on('click', (ev: Event) => {
			ev.preventDefault(); // Prevent default anchor behavior
			$(ev.currentTarget).toggleClass(classes.activeRegisterBtn);
			$registerForm.toggleClass(classes.activeRegisterForm);
		});
	}
}
